import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class ArgomentiService {

  static getArgomentiByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/argomenti/find`;
      ApiService.postRudeRequest(resolve, reject, url, params)
  });
  };

  static createArgomento = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/argomenti/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static updateArgomento = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/argomenti/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };

  static deleteArgomento = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/argomenti/delete`;
      ApiService.delete(resolve, reject, url, data);
    });
  };
}
